export const SET_CANDIDATE_PREF_LANG_REQUEST = "SET_CANDIDATE_PREF_LANG_REQUEST";